module.exports = __webpack_public_path__ + "img/mobil_cim_logo.9e1cb0d9.svg";